import { render } from "./FridgeDetailsTabsItem.vue?vue&type=template&id=7e62e470&scoped=true&ts=true"
import script from "./FridgeDetailsTabsItem.vue?vue&type=script&lang=ts"
export * from "./FridgeDetailsTabsItem.vue?vue&type=script&lang=ts"

import "./FridgeDetailsTabsItem.vue?vue&type=style&index=0&id=7e62e470&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e62e470"]])

export default __exports__